import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthenticationState } from '../store/authentication/authentication.state';

export const emptyRouteGuardFn: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  if (state.url !== '/') return true;

  const isAuthenticated = inject(Store).selectSnapshot(AuthenticationState.isAuthenticated);

  return inject(Router).createUrlTree([isAuthenticated ? '/dashboard' : '/login']);
};
